// Custom Shopify JS — Combined Swiper, Sidebar, Notification, Infinite Scroll

document.addEventListener("DOMContentLoaded", function () {
  // ===================== Swiper Init =====================
  function initSwiper() {
    if (window.swiperInstance) {
      window.swiperInstance.destroy(true, true);
    }
    window.swiperInstance = new Swiper('.swiper-container', {
      lazy: true,
      preloadImages: false,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });
  }

  if (document.querySelector('.swiper-container')) {
    initSwiper();
  }

  // Re-init Swiper on dynamic load
  document.addEventListener('productsLoaded', initSwiper);

  // ===================== Notification Form =====================
  const notifyForm = document.getElementById('NotificaitonFormEmail');
  if (notifyForm) {
    notifyForm.removeAttribute('required');
  }

  // ===================== Sidebar Shop Look =====================
  const sidebar = document.getElementById('sidebar-shop-look');

  // Open
  document.querySelectorAll('.overlay-button').forEach(button => {
    button.addEventListener('click', function (event) {
      event.stopPropagation();
      sidebar?.classList.add('open');
    });
  });

  // Close
  document.querySelector('.sidebar-close')?.addEventListener('click', function () {
    sidebar?.classList.remove('open');
  });

  // ===================== Infinite Scroll =====================
  const container = document.querySelector('#CollectionLoop');
  const loader = document.querySelector('[data-loader]');
  const loaderText = loader?.querySelector('.loader-text');
  const nextBtn = document.querySelector('.pagination-custom__next');

  if (container && loader && nextBtn) {
    let loading = false;
    let nextUrl = nextBtn.getAttribute('href');

    const observer = new IntersectionObserver(async (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting || loading || !nextUrl) return;

        loading = true;
        loader.classList.add('loading');
        loaderText.textContent = 'Loading more products...';

        try {
          const res = await fetch(nextUrl);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');

          const newItems = doc.querySelectorAll('#CollectionLoop > *');
          const newNextBtn = doc.querySelector('.pagination-custom__next');

          newItems.forEach(item => container.appendChild(item));

          if (newNextBtn && newNextBtn.getAttribute('href') !== nextUrl) {
            nextUrl = newNextBtn.getAttribute('href');
            loading = false;
          } else {
            nextUrl = null;
            loaderText.textContent = 'No more products.';
            loader.querySelector('.loader-spinner')?.remove();
          }
        } catch (err) {
          console.error('Infinite Scroll Error:', err);
          loaderText.textContent = 'Failed to load products.';
        }

        loader.classList.remove('loading');
      }
    }, { rootMargin: '600px' });

    observer.observe(loader);
  }
});
